import {
  Component,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Batch } from '../../../models/batch';
import {
  selectAllBatchs,
  selectCurrentReferenceBatchId
} from '../../../features/batch/batch.selectors';
import { selectUser } from '../../../features/user/user.selectors';
import { User } from '../../../models/user';
import { FormControl } from '@angular/forms';
import { selectReferenceBatch } from '../../../features/batch/batch.actions';
import { selectCurrentSite } from '../../../features/site/site.selectors';
import { combineLatest, distinctUntilChanged, withLatestFrom } from 'rxjs';
import { map } from 'rxjs/operators';



@Component({
    selector: 'reference-batch-selector',
    templateUrl: './reference-batch-selector.component.html',
    styleUrls: ['./reference-batch-selector.component.scss'],
    standalone: false
})
export class ReferenceBatchSelectorComponent {

  user: User | null | undefined;
  comparedBatchs: Array<Batch> = [];
  batchControl = new FormControl('');
  readonly dateFormat$ = this.store.select(selectUser).pipe(
    map(user => user?.languageCode === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'),
    distinctUntilChanged()
  );

  constructor(private store: Store) {
    this.handleUser();
    this.handleSiteAndBatchs();
  }


  private handleUser(): void {
    this.store.select(selectUser)
      .pipe(takeUntilDestroyed())
      .subscribe((user: User | undefined) => {
        if (user) {
          this.user = user;
        }
      });
  }

  private handleSiteAndBatchs(): void {
    combineLatest([
      this.store.select(selectCurrentReferenceBatchId),
      this.store.select(selectAllBatchs),
    ])
      .pipe(
        withLatestFrom(
          this.store.select(selectCurrentSite),
        ),
        takeUntilDestroyed()
      )
      .subscribe(([
                    [currentReferenceBatchId, batchs],
                    site
                  ]) => {
        this.batchControl.setValue(null);

        if (site && batchs) {
          this.comparedBatchs = batchs.filter(b => b.id !== site.lastBatch);

          if (this.comparedBatchs.length) {
            if (currentReferenceBatchId) {
              this.batchControl.setValue(currentReferenceBatchId);
            } else {
              this.batchControl.setValue(this.comparedBatchs[0].id);
              this.store.dispatch(
                selectReferenceBatch({ id: this.comparedBatchs[0].id })
              );
            }
          }
        } else {
          this.comparedBatchs = [];
        }
      });
  }

  onChangeBatch(event: any): void {
    this.store.dispatch(selectReferenceBatch({id: event.value}));
  }

}
